import { render } from "./BellIcon.vue?vue&type=template&id=22fb6f8a&scoped=true"
const script = {}

import "./BellIcon.vue?vue&type=style&index=0&id=22fb6f8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fb6f8a"]])

export default __exports__